<div class="editable" *ngIf="!editing" (click)="edit()" (focus)="edit()" tabindex="-1">
  <span class="thumbnail ng-tns-c222-195"
    ><img
      class="ng-tns-c222-195 ng-star-inserted"
      src="https://media.glassdoor.com/l/0d/7a/1e/a1/industrial-building.jpg"
    /><!----><!----></span
  >
</div>
<input
  #inputEditorControl
  currencyMask
  type="text"
  *ngIf="editing"
  (blur)="onBlur($event)"
  (keyup.enter)="onBlur($event)"
  [(ngModel)]="value"
  [options]="currencyMaskOptions"
  [disabled]="isDisabled"
/>
